export const formatPhone = (string) => string?.replace?.(/[\s()_+-]/g, '').trim();

export const removeMaskSymbols = (phone) => phone?.replace?.('+', '')
  .replace('(', '')
  .replace(')', '')
  .replaceAll('_', '')
  .replaceAll('/', '')
  .replaceAll('\\', '')
  .replaceAll('-', '');

export const removeSubjectNameSymbols = (phone) => (typeof phone !== 'string' ? '' : phone
  .replaceAll('/', '')
  .replaceAll('\\', ''));

const rusAlphabet = 'йцукенгшщзхъфывапролджэячсмитьбюё1234567890';
export const formatTSString = (value) => {
  if (typeof value === 'string') {
    const arrayString = value.split('');
    const needSigns = arrayString.filter((valueSign) => rusAlphabet.includes(valueSign.toLowerCase()));
    return needSigns.join('');
  }
  return '';
};

export const stringWithLabel = (string, label = '', additionalSign = '') => (string ? `${label}${string}${additionalSign} ` : '');

export const includesString = (string1, string2) => typeof string1 === 'string' && typeof string2 === 'string' && string1.toLowerCase().includes(string2.toLowerCase());

export const formatAddressString = (address = {}, additionalSign = ',') => (stringWithLabel(address?.region, 'Регион ', additionalSign)
  + stringWithLabel(address?.district, 'район ', additionalSign)
  + stringWithLabel(address?.city, 'поселение ', additionalSign)
  + stringWithLabel(address?.street, 'ул. ')
  + stringWithLabel(address?.house, 'дом ')
  + stringWithLabel(address?.hull_number, 'корпус ')
  + stringWithLabel(address?.building_number, 'строение'));

export const formatObjectWithAddress = ({ objective }) => {
  const objectiveAttributes = objective?.objective_attributes?.attributes?.name ? objective?.objective_attributes?.attributes : objective;
  const objectName = objectiveAttributes?.name;
  if (!objectName) return '';

  const objectAddress = objectiveAttributes?.address_attributes?.attributes;

  return (`${objectName} ${formatAddressString(objectAddress)}`)?.trim?.() || '';
};

export const formatPDFAddressString = (address = {}) => stringWithLabel(address?.region)
  + stringWithLabel(address?.district)
  + stringWithLabel(address?.city)
  + stringWithLabel(address?.street)
  + stringWithLabel(address?.house);

export const getOktmoLabel = (item) => (item?.name ? `${item.code} ${item.name}`.trim() : '');

const prefixNumber = (str) => {
  if (str === '7') {
    return '7 (';
  }
  if (str === '8') {
    return '8 (';
  }
  if (str === '9') {
    return '7 (9';
  }
  return '7 (';
};

export const stringToPhone = (string) => {
  const value = string.replace(/\D+/g, '');
  const numberLength = 11;

  let result;
  if (string.includes('+8') || string[0] === '8') {
    result = '';
  } else {
    result = '+';
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < value.length && i < numberLength; i++) {
    switch (i) {
      case 0:
        result += prefixNumber(value[i]);
        // eslint-disable-next-line no-continue
        continue;
      case 4:
        result += ') ';
        break;
      case 7:
        result += '-';
        break;
      case 9:
        result += '-';
        break;
      default:
        break;
    }
    result += value[i];
  }
  if (typeof result === 'string' && result.length === 1) {
    result = '';
  }

  return result;
};

export const stringWithStartEnd = ({ string, start = '', end = '' }) => (string ? `${start}${string}${end}` : '');

export const upperCaseFirstLetter = (string) => (typeof string === 'string' && string ? `${string[0].toUpperCase()}${string.slice(1, string.length)}` : string);

export const getFullName = ({
  last_name,
  first_name,
  middle_name,
} = {}) => `${stringWithLabel(last_name)}${stringWithLabel(first_name)}${stringWithLabel(middle_name)}`;

export const sliceLongString = (string, shouldSlice) => {
  if (shouldSlice && typeof string === 'string' && string.length > 100) {
    return `${string.slice(0, 97)}...`;
  }
  return string;
};

export const valueToString = (value) => value?.toString?.() || '';

export const EGRZ_MASK = 'a999aa999';
export const EGRZ_MASK_LENGTH = EGRZ_MASK.length;
